import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DDosmain from './components/DDosmain';
import Partners from './components/Partners';
import Requestform from './components/Requestform';
import Cards from './components/Cards';
import Vendors from './components/Vendors';
import Footer from './components/Footer';

const MainPage = () => {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <Hero />
      <DDosmain />
      <Cards />
      <Partners />
      <Vendors />
      <Requestform />
      <Footer />
    </div>
  );
};

export default MainPage;
